import nativeHttp from '@/utils/native/http'

// 可用值:CANCEL,WAIT,FINISH

export function getOrderStatus(orderNo: string): Promise<'CANCEL' | 'WAIT' | 'FINISH'> {
  return nativeHttp.post(`user/order/getOrderStatus`, {
    orderNo,
  })
}
